import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppContext } from '../Shared/common';
import { IOrganisation } from '../Models/Common/Organisation';

@Injectable()
export class OrgInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private appctx: AppContext) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentOrg = this.authService.getCurrentOrganization();
    const authToken = this.authService.getAuthToken();
    const unitId = this.getUnitId(currentOrg);

    // Add org context to headers
    if (currentOrg) {
      request = request.clone({
        setHeaders: {
          'X-Org-Id': currentOrg.OrgId.toString(),
          'X-Unit-Id': unitId,
          'OrgId': currentOrg.OrgId.toString(),
          'UnitId': unitId
        }
      });
    }

    // Add auth token
    if (authToken && !request.url.includes('/login')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    return next.handle(request);
  }

  private getUnitId(org:IOrganisation): string {
    try {
      if (org?.OrgUnits) {
        const selectedUnit = org.OrgUnits.find(x => x.IsSelected);
        if (selectedUnit?.UnitId) {
          return selectedUnit.UnitId.toString();
        }
        else {
          return org.OrgUnits[0]?.UnitId.toString() || '';
        }
      }
    } catch (e) {
    }
    return '';
  }
}
